
import { h, Fragment } from 'preact'
import Container from '@components/container'
import { widows } from '@util/typography'
import { ButtonText } from '@components/button'
import classnames from 'classnames'
import ModuleWhatWeDo from '@components/what-we-do'

export default (data) => {
	
	return <ModuleWhatWeDo items={{
		whatWeDo : [
			{ 
				title: 'Employer brand & EVP', 
				howWeDoIt: ['Narrative development', 'Creative campaigns & design', 'Social media strategy & management', 'Data & reporting', 'Digital solutions', 'Career site strategy & management', 'Motion graphics strategy and production', 'Media & channel strategy', 'Research & insight'], 
				description: 'Using research to develop compelling messages for your potential and existing talent' 
			},
			{ 
				title: 'Early talent attraction', 
				howWeDoIt: ['Narrative development', 'Creative campaigns & design', 'Social media strategy & management', 'Data & reporting', 'Digital solutions', 'Career site strategy & management', 'Motion graphics strategy and production', 'Media & channel strategy', 'Research & insight'], 
				description: 'Delivering multi-platform recruitment campaigns, from apprentices to post-graduates'
			},
			{ 
				title: 'Employer marketing', 
				howWeDoIt: ['Narrative development', 'Creative campaigns & design', 'Social media strategy & management', 'Data & reporting', 'Digital solutions', 'Career site strategy & management', 'Motion graphics strategy and production', 'Media & channel strategy', 'Research & insight'], 
				description: 'Creating assets, from job ads to immersive events, that bring life to your employer brand' 
			},
			{ 
				title: 'Employee engagement', 
				howWeDoIt: ['Narrative development', 'Creative campaigns & design', 'Data & reporting', 'Digital solutions', 'Motion graphics strategy and production', 'Research & insight'], 
				description: 'Deploying communications that help instil loyalty and encourage discretionary effort' 
			},
			{ 
				title: 'Candidate experience', 
				howWeDoIt:  ['Narrative development', 'Social media strategy & management', 'Data & reporting', 'Digital solutions', 'Career site strategy & management', 'Motion graphics strategy and production', 'Media & channel strategy', 'Research & insight'], 
				description: 'Developing applicant journeys that keep talent locked in – and do your brand proud' 
			},
			{ 
				title: 'Vision & values', 
				howWeDoIt: ['Narrative development', 'Creative campaigns & design', 'Digital solutions', 'Motion graphics strategy and production', 'Research & insight'], 
				description: 'Defining, refreshing and sharing vision, values, mission and purpose ' 
			},
			{ 
				title: 'Strategy comms', 
				howWeDoIt: ['Narrative development', 'Creative campaigns & design', 'Social media strategy & management', 'Digital solutions', 'Motion graphics strategy and production', 'Research & insight'], 
				description: 'Ensuring everyone understands the bigger picture, and what’s in it for them' 
			},
			{ 
				title: 'L&D marketing', 
				howWeDoIt: ['Narrative development', 'Creative campaigns & design', 'Digital solutions', 'Motion graphics strategy and production', 'Research & insight'],  
				description: 'Communicating a learning proposition so everyone wants to know more' 
			},
			{ 
				title: 'D&I comms', 
				howWeDoIt: ['Narrative development', 'Creative campaigns & design', 'Social media strategy & management', 'Data & reporting', 'Digital solutions', 'Career site strategy & management', 'Motion graphics strategy and production', 'Media & channel strategy', 'Research & insight'], 
				description: 'Putting diversity and inclusion at the heart of the organisation' 
			},
		],
		howWeDoIt : [
			{ title: 'Narrative development', description: 'Creating stories that engage hearts and minds' },
			{ title: 'Creative campaigns & design', description: 'Satisfying brand requirements and getting the right results' },
			{ title: 'Social media strategy & management', description: 'Delivering great content and enabling inspiring dialogues' },
			{ title: 'Data & reporting', description: 'Finding the data that drives continuous improvement' },
			{ title: 'Digital solutions', description: 'Supplier-agnostic consulting, from tech stacks to job boards' },
			{ title: 'Career site strategy & management', description: 'Creating and refreshing EVP-aligned careers sites' },
			{ title: 'Motion graphics strategy and production', description: 'Film and animation, from one-offs to bingeworthy series' },
			{ title: 'Media & channel strategy', description: 'Data-centric planning and measurement of message placement' },
			{ title: 'Research & insight', description: 'Qualitative and quantitative tools to inform key decisions' },
		]
	}} />
}
